import React, { useState, PropsWithChildren, useMemo, useContext } from 'react';

import type { MediaId } from '~/common';

import { ExtendedBrightcovePlayer } from './types';

type Value = {
  player: ExtendedBrightcovePlayer | null;
  mediaId: MediaId;
  setPlayer: (value: ExtendedBrightcovePlayer | null) => void;
};

export const MediaPlayerContext = React.createContext<Value | undefined>(undefined);

export const MediaPlayerProvider: React.FC<
  PropsWithChildren<{
    mediaId: MediaId;
  }>
> = ({ children, mediaId }) => {
  const [player, setPlayer] = useState<ExtendedBrightcovePlayer | null>(null);

  const value = useMemo(() => {
    return {
      mediaId,
      player,
      setPlayer,
    };
  }, [player, mediaId]);
  return <MediaPlayerContext.Provider value={value}>{children}</MediaPlayerContext.Provider>;
};

export function useMediaPlayer() {
  const context = useContext(MediaPlayerContext);
  if (typeof context === 'undefined') {
    throw new Error('useMediaPlayer must be used within a MediaPlayerContextd');
  }
  return context;
}
